import legacyMessages from "@/lang/languages";
import esMessages from "./locales/es.json";
import enMessages from "./locales/en.json";
import esAdminMessages from "./locales/es/admin.json";
import enAdminMessages from "./locales/en/admin.json";
import esCalendarMessages from "./locales/es/calendar.json";
import enCalendarMessages from "./locales/en/calendar.json";
import esChatbotMessages from "./locales/es/chatbot.json";
import enChatbotMessages from "./locales/en/chatbot.json";
import esConversationMessages from "./locales/es/conversation.json";
import enConversationMessages from "./locales/en/conversation.json";
import esCustomerMessages from "./locales/es/customer.json";
import enCustomerMessages from "./locales/en/customer.json";
import esDashboardMessages from "./locales/es/dashboard.json";
import enDashboardMessages from "./locales/en/dashboard.json";
import esItineraryMessages from "./locales/es/itinerary.json";
import enItineraryMessages from "./locales/en/itinerary.json";
import esMarketingMessages from "./locales/es/marketing.json";
import enMarketingMessages from "./locales/en/marketing.json";
import esOrganizationMessages from "./locales/es/organization.json";
import enOrganizationMessages from "./locales/en/organization.json";
import esPackagesMessages from "./locales/es/packages.json";
import enPackagesMessages from "./locales/en/packages.json";
import esPdfMessages from "./locales/es/pdf.json";
import enPdfMessages from "./locales/en/pdf.json";
import esProviderMessages from "./locales/es/provider.json";
import enProviderMessages from "./locales/en/provider.json";
import esReservationsMessages from "./locales/es/reservations.json";
import enReservationsMessages from "./locales/en/reservations.json";
import esServicesMessages from "./locales/es/services.json";
import enServicesMessages from "./locales/en/services.json";
import esSettingsMessages from "./locales/es/settings.json";
import enSettingsMessages from "./locales/en/settings.json";
import esShellMessages from "./locales/es/shell.json";
import enShellMessages from "./locales/en/shell.json";
import esReviewsMessages from "./locales/es/reviews.json";
import enReviewsMessages from "./locales/en/reviews.json";
function isPlainObject(value) {
    return typeof value === "object" && value !== null && !Array.isArray(value);
}
function mergeMessages(base, extension) {
    const merged = { ...base };
    for (const [key, value] of Object.entries(extension)) {
        const existing = merged[key];
        merged[key] =
            isPlainObject(existing) && isPlainObject(value)
                ? mergeMessages(existing, value)
                : value;
    }
    return merged;
}
function namespaceMessages(namespace, messages) {
    const nested = isPlainObject(messages[namespace]) ? messages[namespace] : {};
    const rest = { ...messages };
    delete rest[namespace];
    return {
        [namespace]: mergeMessages(nested, rest),
    };
}
const domainMessages = {
    admin: {
        es: esAdminMessages,
        en: enAdminMessages,
    },
    calendar: {
        es: esCalendarMessages,
        en: enCalendarMessages,
    },
    chatbot: {
        es: esChatbotMessages,
        en: enChatbotMessages,
    },
    conversation: {
        es: esConversationMessages,
        en: enConversationMessages,
    },
    customer: {
        es: esCustomerMessages,
        en: enCustomerMessages,
    },
    dashboard: {
        es: esDashboardMessages,
        en: enDashboardMessages,
    },
    itinerary: {
        es: esItineraryMessages,
        en: enItineraryMessages,
    },
    marketing: {
        es: esMarketingMessages,
        en: enMarketingMessages,
    },
    organization: {
        es: esOrganizationMessages,
        en: enOrganizationMessages,
    },
    packages: {
        es: esPackagesMessages,
        en: enPackagesMessages,
    },
    pdf: {
        es: esPdfMessages,
        en: enPdfMessages,
    },
    provider: {
        es: esProviderMessages,
        en: enProviderMessages,
    },
    reservations: {
        es: esReservationsMessages,
        en: enReservationsMessages,
    },
    services: {
        es: esServicesMessages,
        en: enServicesMessages,
    },
    settings: {
        es: esSettingsMessages,
        en: enSettingsMessages,
    },
    shell: {
        es: esShellMessages,
        en: enShellMessages,
    },
    reviews: {
        es: esReviewsMessages,
        en: enReviewsMessages,
    },
};
function localeMessages(locale, base) {
    return Object.entries(domainMessages)
        .map(([namespace, messages]) => namespaceMessages(namespace, messages[locale]))
        .reduce(mergeMessages, base);
}
export default {
    es: localeMessages("es", mergeMessages(legacyMessages.es ?? {}, esMessages)),
    en: localeMessages("en", mergeMessages(legacyMessages.en ?? {}, enMessages)),
};
